import httpClient from "../../../shared/api/httpClient";

// Assinatura pelo gateway (Asaas). O backend responde 503 enquanto a integração não
// estiver configurada — quem chama decide o que fazer (ex.: cair no link alternativo).
export const billingApi = {
  getStatus: () => httpClient.get("/api/v1/billing/status").then((r) => r.data.dados),
  checkout: () => httpClient.post("/api/v1/billing/checkout").then((r) => r.data.dados.checkout_url),
  cancel: () => httpClient.post("/api/v1/billing/cancel").then((r) => r.data.dados),
};
